import React from 'react';
import styles from './PriceBox.module.scss';
import numeral from 'numeral';
import {currencyValueToLabel} from 'gui/components/formikCurrencySelector';
import SkeletonPlaceHolder from 'gui/components/skeletonPlaceHolder';

interface IPriceBoxProps {
  labelClassName?: string;
  priceClassName?: string;
  label: string;
  price: number;
  currency?: number;

  loading?: boolean;
}

const PriceBox = (props: IPriceBoxProps) => (
  <div className={`${styles.priceBox} priceBox`}>
    <div className={`${styles.label} ${props.labelClassName}`}>
      {props.label}:
    </div>
    {props.loading ? <SkeletonPlaceHolder variant="text" width={85}/> :
      <div className={`${styles.price} ${props.priceClassName}`}>
        <span> {numeral(props.price).format("0,0")}</span>
        <span>&nbsp;</span>
        <span>{currencyValueToLabel[props.currency] || currencyValueToLabel[2]}</span>
      </div>}
  </div>

);

PriceBox.defaultProps = {
  labelClassName: '',
  priceClassName: '',
};
export default PriceBox;
